import type { Group } from '../types/common';

/**
 * Filters out duplicate groups by their name.
 * If multiple groups have the same name, only the first occurrence is kept.
 *
 * @param groups - An array of Group objects to filter.
 */
export const uniqueGroupByName = (groups: Group[]): Group[] => {
  const uniqueGroups: Record<string, Group> = {};

  groups.forEach(group => {
    if (!uniqueGroups[group.name]) {
      uniqueGroups[group.name] = group;
    }
  });

  return Object.values(uniqueGroups);
};
